/**
 * Click-to-copy and details dialog for the Promo message snippet.
 * Delegated from the document so codes added by section re-renders (theme
 * editor, variant swaps) keep working without re-binding.
 */
(function () {
  if (window.__bmPromoMessageBound) return;
  window.__bmPromoMessageBound = true;

  var RESET_MS = 1800;
  var timers = new WeakMap();

  function announce(text) {
    var region = document.getElementById("bm-promo-status");
    if (!region) {
      region = document.createElement("span");
      region.id = "bm-promo-status";
      region.className = "bm-promo__status";
      region.setAttribute("role", "status");
      region.setAttribute("aria-live", "polite");
      document.body.appendChild(region);
    }
    region.textContent = text;
  }

  function legacyCopy(text) {
    var field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "readonly");
    field.style.position = "fixed";
    field.style.top = "-1000px";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();

    var copied = false;
    try {
      copied = document.execCommand("copy");
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(field);
    return copied;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () {
          return true;
        },
        function () {
          return legacyCopy(text);
        },
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  function flash(button, message) {
    var label = button.querySelector(".bm-promo__code-label");
    if (!label) return;

    if (!button.dataset.bmOriginal) {
      button.dataset.bmOriginal = label.textContent;
    }

    label.textContent = message;
    button.classList.add("is-copied");

    clearTimeout(timers.get(button));
    timers.set(
      button,
      setTimeout(function () {
        label.textContent = button.dataset.bmOriginal;
        button.classList.remove("is-copied");
      }, RESET_MS),
    );
  }

  function openDialog(dialog) {
    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.classList.add("bm-promo__dialog--fallback", "is-open");
      dialog.setAttribute("open", "open");
    }

    var focusable = dialog.querySelector("[data-bm-dialog-close]");
    if (focusable) focusable.focus();
  }

  function closeDialog(dialog) {
    if (dialog.classList.contains("bm-promo__dialog--fallback")) {
      dialog.classList.remove("is-open");
      dialog.removeAttribute("open");
    } else if (typeof dialog.close === "function") {
      dialog.close();
    }

    var opener = document.querySelector('[data-bm-dialog="' + dialog.id + '"]');
    if (opener) opener.focus();
  }

  document.addEventListener("click", function (event) {
    var node = event.target;
    if (!node || !node.closest) return;

    var opener = node.closest("[data-bm-dialog]");
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute("data-bm-dialog"));
      if (dialog) {
        event.preventDefault();
        openDialog(dialog);
        return;
      }
    }

    var closer = node.closest("[data-bm-dialog-close]");
    if (closer) {
      var owned = closer.closest(".bm-promo__dialog");
      if (owned) {
        event.preventDefault();
        closeDialog(owned);
        return;
      }
    }

    // Clicking the backdrop (the dialog element itself, outside its panel).
    if (node.classList && node.classList.contains("bm-promo__dialog")) {
      closeDialog(node);
      return;
    }
  });

  // Esc is native for <dialog>; the fallback needs it wired up.
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var open = document.querySelector(".bm-promo__dialog--fallback.is-open");
    if (open) closeDialog(open);
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest("[data-bm-code]") : null;
    if (!button) return;

    event.preventDefault();

    var code = button.getAttribute("data-bm-code") || "";
    var copiedLabel = button.getAttribute("data-bm-copied") || "Copied!";
    if (!code) return;

    copy(code).then(function (ok) {
      if (ok) {
        flash(button, copiedLabel);
        announce(copiedLabel + " " + code);
      } else {
        // Copying is blocked (older browser, denied permission): select the
        // code so the customer can copy it by hand.
        var label = button.querySelector(".bm-promo__code-label");
        if (label && window.getSelection && document.createRange) {
          var range = document.createRange();
          range.selectNodeContents(label);
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
        announce("Select and copy the code " + code);
      }
    });
  });
})();